var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/logos", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.logo
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.updateLogo.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.siteNameText,
                              expression: "rules.siteNameText"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Site Name",
                            placeholder: "Enter Name",
                            "data-vv-name": "site",
                            "cus-name": "site",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.logo.siteNameText,
                            callback: function($$v) {
                              _vm.$set(_vm.logo, "siteNameText", $$v)
                            },
                            expression: "logo.siteNameText"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.linkDestination,
                              expression: "rules.linkDestination"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Site URL",
                            placeholder: "Enter URL",
                            "data-vv-name": "URL",
                            "cus-name": "URL",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.logo.linkDestination,
                            callback: function($$v) {
                              _vm.$set(_vm.logo, "linkDestination", $$v)
                            },
                            expression: "logo.linkDestination"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.pages.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.pageName,
                                  expression: "rules.pageName"
                                }
                              ],
                              attrs: {
                                label: "Page",
                                "data-vv-name": "pageName",
                                "cus-name": "pageName",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.pages,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.logo.pageName,
                                callback: function($$v) {
                                  _vm.$set(_vm.logo, "pageName", $$v)
                                },
                                expression: "logo.pageName"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.logoUrl,
                              expression: "rules.logoUrl"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Logo URL (200 X 200)",
                            placeholder: "Enter Logo URL",
                            "data-vv-name": "logo URL",
                            "cus-name": "logo URL",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.logo.logoUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.logo, "logoUrl", $$v)
                            },
                            expression: "logo.logoUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.status.length
                      ? _c(
                          "div",
                          { staticClass: "col-3" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.active,
                                  expression: "rules.active"
                                }
                              ],
                              attrs: {
                                label: "Status",
                                "data-vv-name": "active",
                                "cus-name": "active",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.status,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.logo.active,
                                callback: function($$v) {
                                  _vm.$set(_vm.logo, "active", $$v)
                                },
                                expression: "logo.active"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                        Update Logo\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Edit Logo")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b32b1c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b32b1c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Logos/EditLogo.vue
// module id = /4+u
// module chunks = 0